<template>
  <dl class="definition-list">
    <template v-for="item in items">
      <dt>{{item.name}}</dt>
      <dd>{{item.value}}</dd>
    </template>
  </dl>
</template>

<script>
export default {
  name: 'definition-list',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>



// WEBPACK FOOTER //
// DefinitionList.vue?1875d034